import * as React from 'react';

import { DataItemImportance } from '../../misc/api/apiTypes';
import Condition from '../../misc/components/Condition';
import { ConfigFieldValidation } from '../validation/ConfigurableItemValidator';
import { TextBox } from './TextBoxV4';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { useFieldState, useField } from 'informedv4';
import { inputClasses } from '../validation/ValidationClasses';
import { ConfigurableDataItemIds } from '../../misc/api/ApiConfigurableDataItems';
import { useReferenceContextProvider } from '../../Core/ReferenceContextProvider';

interface ConfigFieldTextBoxProps {
    id: string;
    name: string;
    field: string;
    className: string;
    disabled?: boolean;
    hidden?: boolean;
    validated: boolean;
    required?: boolean;
    itemId: ConfigurableDataItemIds;
    isInputAddon?: boolean;
    inputAddon?: React.ReactNode;
    type?: string;
    autoComplete?: string;
    onBlur?: React.FocusEventHandler<HTMLInputElement>;
}

export const ConfigFieldTextBox = ({
    id,
    field,
    name,
    className,
    disabled,
    hidden,
    validated,
    required,
    itemId,
    isInputAddon,
    inputAddon,
    type,
    autoComplete,
    onBlur
}: ConfigFieldTextBoxProps): JSX.Element => {
    const { dataItemConfigurationCollection } = useCurrentStudyConfigurationContext();
    const { unitTypes } = useReferenceContextProvider();

    if (dataItemConfigurationCollection == null) {
        throw new Error('Fields Configurations is not set');
    }

    const item = dataItemConfigurationCollection.find(
        x => x.configurableDataItemId === itemId
    );
    if (!item) {
        throw new Error(`Config item not found for id: ${String(itemId)}`);
    }

    const { fieldApi, fieldState, ref, userProps } = useField({
        name,
        type: 'text',
    });

    const { error, showError } = useFieldState(name);

    return (
        <Condition test={() => item.importanceId !== DataItemImportance.NotApplicable}>
            <div className={className} hidden={hidden} data-automationid={`${id}-form-group`}>
                <label htmlFor={id}>{item.displayText}</label>
                <TextBox
                    field={field}
                    id={id}
                    name={name}
                    className={inputClasses(error as string)}
                    aria-invalid={!!(showError && error)}
                    validateOn="submit"
                    validate={ConfigFieldValidation(item, required, validated)}
                    disabled={disabled}
                    type={type}
                    onBlur={onBlur}
                    autoComplete={autoComplete}

                    inputAddon={
                        isInputAddon && inputAddon === undefined
                            ? unitTypes.find(ut => ut.id === item.unitTypeId)?.name
                            : inputAddon
                    }
                />
            </div>
        </Condition>
    );
};
